import React from "react";
import { Navigate } from "react-router-dom";
import { useAppContext } from "contexts";

const ProtectedRoutes = ({ children }) => {
  const { user, isLoading } = useAppContext();

  return !isLoading && user?.uid ? children : <Navigate to="/login" />;
};

const SuperAdminRoutes = ({ children }) => {
  const { user, isLoading } = useAppContext();
  return !isLoading && user?.uid && user?.role === "super-admin" ? (
    children
  ) : (
    <Navigate to="/login" />
  );
};

export { SuperAdminRoutes, ProtectedRoutes };
